import { Controller } from "@hotwired/stimulus";
import { initDropzone, initDropzoneBasicEvents, handleDropzoneUploadSuccess } from "../../components/dropzone";
import { toggleClass } from "../../utils/misc";

export default class extends Controller {
  static targets = ["filePreviewsContainer", "uploadImgLabel", "submitBtn", "dragAndDropContainer"];
  static values = { uploadOptions: Object };

  connect() {
    /* Victor Desjardins : Due to the weirdest thing I saw it doesnt work in staging/prod environment work without that comment */
    this._initDropzone();
  }

  validateSubmission(e) {
    e.preventDefault();
    this.dropzone.processQueue();
  }

  documentUploaded() {
    document.dispatchEvent(new CustomEvent("todo:documentUploaded"));
  }

  _initDropzone() {
    this.dropzone = initDropzone(this.element.id, {}, this._uploadOptions());
    initDropzoneBasicEvents(this.dropzone, this.uploadImgLabelTarget, this.dragAndDropContainerTarget);
    this._initCustomEvents();
  }

  _uploadOptions() {
    return {
      previewsContainer: this.filePreviewsContainerTarget,
      maxFiles: this.uploadOptionsValue.max_files,
      acceptedFiles: this.uploadOptionsValue.accepted_files,
      clickable: `#${this.dragAndDropContainerTarget.id}`,
    };
  }

  _initCustomEvents() {
    this.dropzone.on("addedfiles", () => {
      this._toggleSubmitBtn();
    });

    this.dropzone.on("removedfile", () => {
      this._toggleSubmitBtn();
    });

    handleDropzoneUploadSuccess(this.dropzone, this.element);
  }

  _toggleSubmitBtn() {
    const hasAcceptedFiles = this.dropzone.files.length > 0;
    toggleClass(this.submitBtnTarget, "hidden", hasAcceptedFiles);
  }
}
